export const isLogin = () => {
  return sessionStorage.getItem("loginInfo");
};
export const saveLoginInfo = (data) => {
  sessionStorage.setItem("loginInfo", JSON.stringify(data));
};
export const removeLoginInfo = () => {
  sessionStorage.removeItem("loginInfo");
};
export const getToken = () => {
  return JSON.parse(sessionStorage.getItem("loginInfo")).refreshToken;
};
export const updateToken = (value) => {
  let data = JSON.parse(sessionStorage.getItem("loginInfo"));
  data.accessToken = value;
  sessionStorage.setItem("loginInfo", JSON.stringify(data));
};
export const accessToken = () => {
  return sessionStorage.getItem("loginInfo")
    ? JSON.parse(sessionStorage.getItem("loginInfo")).accessToken
    : null;
};
export const upload_token = () => {
  return sessionStorage.getItem("loginInfo")
    ? JSON.parse(sessionStorage.getItem("loginInfo")).upToken
    : null;
};
